export const SEARCH_DRIVEN_STORE_PICKER_ROULETTE = 'rt_search_driven_store_picker_enabled'

export const isSearchDrivenStorePickerPartner = (
  partnerFeatureToggles?: { name: string }[] | null
): boolean =>
  !!partnerFeatureToggles?.some(toggle => toggle.name === SEARCH_DRIVEN_STORE_PICKER_ROULETTE)
